import Axios from "axios";

export class InfoAccionistaService {

    lista(params, op) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/matriz/accionista-p${op}/lista?${queryParams}`).then(res => res.data);
    }

    nuevo(data, op) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/matriz/accionista-p${op}/nuevo`, data).then(res => res.data);
    }

    editar(data, op) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/matriz/accionista-p${op}/editar`, data).then(res => res.data);
    }

    consultar(id, op) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/matriz/accionista-p${op}/consulta/${id}`).then(res => res.data);
    }

    eliminar(id, op) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/matriz/accionista-p${op}/eliminar/${id}`).then(res => res.data);
    }

    informacion(id, num, op) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/matriz/accionista-p${op}${num}/informacion/${id}`).then(res => res.data);
    }

    detalle(data, num, op) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/matriz/accionista-p${op}${num}-detalle/procesar`, data).then(res => res.data);
    }

    finalizar(data, num, op) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/matriz/accionista-p${op}${num}-estado/procesar`, data).then(res => res.data);
    }

    volverBorrador(data, num, op) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/matriz/accionista-p${op}${num}-estado/borrador`, data).then(res => res.data);
    }

    descargar(id, num, op) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/matriz/accionista-p${op}${num}/reporte/${id}`, {
            headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache' },
            responseType: 'blob'
        }).then(async res => res.data);
    }
}
